import { FormattedMessage } from '@subaio/components'

export const policies: Record<string, React.JSX.Element> = {
	coverdDamages: (
		<FormattedMessage id='opportunityCarInsurance.policies.coverdDamages' defaultMessage='Covered damages' />
	),
	freeInsured: <FormattedMessage id='opportunityCarInsurance.policies.freeInsured' defaultMessage='Free insured' />,
	accessoriesComposation: (
		<FormattedMessage
			id='opportunityCarInsurance.policies.accessoriesComposation'
			defaultMessage='Accessories compensation'
		/>
	),
	replacementVehicle: (
		<FormattedMessage id='opportunityCarInsurance.policies.replacementVehicle' defaultMessage='Replacement vehicle' />
	),
	exclusions: <FormattedMessage id='opportunityCarInsurance.policies.exclusions' defaultMessage='Exclusions' />,
	acquisitionRegulation: (
		<FormattedMessage
			id='opportunityCarInsurance.policies.acquisitionRegulation'
			defaultMessage='Acquisition regulation'
		/>
	),
	purchaseRegulation: (
		<FormattedMessage id='opportunityCarInsurance.policies.purchaseRegulation' defaultMessage='Purchase regulation' />
	),
	dayValueRegulation: (
		<FormattedMessage id='opportunityCarInsurance.policies.dayValueRegulation' defaultMessage='Day value regulation' />
	),
	securityNotes: (
		<FormattedMessage id='opportunityCarInsurance.policies.securityNotes' defaultMessage='Security notes' />
	),
	ownRisk: <FormattedMessage id='opportunityCarInsurance.policies.ownRisk' defaultMessage='Own risk' />,
	damageRepairNotes: (
		<FormattedMessage id='opportunityCarInsurance.policies.damageRepairNotes' defaultMessage='Damage repair notes' />
	),
	repairsWithoutExpert: (
		<FormattedMessage
			id='opportunityCarInsurance.policies.repairsWithoutExpert'
			defaultMessage='Repairs without expert'
		/>
	),
	bmDamageNotes: (
		<FormattedMessage id='opportunityCarInsurance.policies.bmDamageNotes' defaultMessage='BM damage notes' />
	),
	noClaimNotes: <FormattedMessage id='opportunityCarInsurance.policies.noClaimNotes' defaultMessage='No claim notes' />,
	nationalAssistance: (
		<FormattedMessage id='opportunityCarInsurance.policies.nationalAssistance' defaultMessage='National assistance' />
	),
	internationalAssistance: (
		<FormattedMessage
			id='opportunityCarInsurance.policies.internationalAssistance'
			defaultMessage='International assistance'
		/>
	),
	terminationNotes: (
		<FormattedMessage id='opportunityCarInsurance.policies.terminationNotes' defaultMessage='Termination notes' />
	),
	passengersCoverage: (
		<FormattedMessage id='opportunityCarInsurance.policies.passengersCoverage' defaultMessage='Passengers coverage' />
	),
	occupantsCoverage: (
		<FormattedMessage id='opportunityCarInsurance.policies.occupantsCoverage' defaultMessage='Occupants coverage' />
	),
	legalCoverage: (
		<FormattedMessage id='opportunityCarInsurance.policies.legalCoverage' defaultMessage='Legal coverage' />
	),
}
